const ClickSvg = ({ fill = '#FFF', width = '12', height = '10'}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 10" fill="none">
      <path d="M4.51122 10L0 5.58831L2.02991 3.68424L4.5 6L9.97009 0L12 1.90407L4.51122 10Z" fill={fill}/>
    </svg>
  )
}
export default ClickSvg
